<template>
  <div>
    <form
      class="login-form basic-form"
      v-if="done === false"
      @submit.prevent="saveData()"
      autocomplete="off"
      novalidate
    >
      <div class="header">{{ $t("have_you_forgot_password") }}</div>
      <p class="description">
        {{ $t("have_you_forgot_password_information") }}
      </p>

      <vue-form-generator
        ref="mainForm"
        :schema="schema"
        :model="model"
        :options="formOptions"
      />

      <div class="text-right">
        <button type="submit" class="btn pl-4 pr-4 btn-warning">
          {{ $t("change_password") }}
        </button>
      </div>
    </form>
    <div class="basic-form text-center" v-if="done === true">
      <div class="header">
        {{ $t("change_password_request_sent") }}
      </div>
      <p class="description">
        {{ $t("change_password_request_sent_information") }}
      </p>
    </div>
  </div>
</template>

<script>
import { validateForm } from "@/utils";

export default {
  name: "LostPassword",
  methods: {
    saveData() {
      if (validateForm(this.$refs.mainForm)) {
        this.$store.dispatch("account/lostPassword", this.model).then(() => {
          this.done = true;
        });
      }
    }
  },
  data() {
    return {
      done: false,
      model: {
        login: ""
      },
      schema: {
        fields: [
          {
            type: "input",
            inputType: "email",
            placeholder: this.$t("client_id"),
            model: "login",
            required: true
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: false,
        validateAsync: false
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
